import firebase from "firebase";

export const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
export const gmailAuthProvider = new firebase.auth.GoogleAuthProvider();
